import Home from "../Home";

const Electronics = () => {
  return (
    <Home url={"https://fakestoreapi.com/products/category/electronics"} />
  );
};

export default Electronics;
